import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TrackLinkDirective } from '@analytics/events';

@Component({
  selector: 'wl-navigation-ecmp-logo',
  standalone: true,
  imports: [NgClass, TrackLinkDirective],
  templateUrl: './navigation-ecmp-logo.component.html',
  styleUrls: [
    './navigation-ecmp-logo.component.ed.scss',
    './navigation-ecmp-logo.component.essent.scss',
  ],
})
export class NavigationEcmpLogoComponent {
  readonly label = input.required();
  readonly url = input.required();
  readonly src = input.required();
  readonly target = input('_blank');

  /** A dividing line left of the logo (so it can be placed nex to another logo */
  readonly withLeftDivider = input(true);
}
